import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiBaseUrl } from '../../config';
import { ApiContentResponse } from '../../models/api/apiResponse';
import { PublicProfileTipRules } from '../../models/user';
import { PublicTeamTipRules } from '../../models/team';
import { CheckoutDetails } from '../../models/checkoutDetails';
import { CheckoutStatus } from '../../models/checkoutStatus';

const baseQuery = fetchBaseQuery({
    baseUrl: `${apiBaseUrl}`,
});

export const api = createApi({
    reducerPath: 'api',
    baseQuery,
    endpoints: (builder) => ({
        // GET /public-profile/${memberId}?include-tip-rules=true
        getPublicProfile: builder.query<
            ApiContentResponse<PublicProfileTipRules>,
            string
        >({
            query: (memberId: string) => ({
                url: `/public-profile/${memberId}?include-tip-rules=true`,
                method: `GET`,
            }),
        }),

        // GET /public-team/${teamId}?include-tip-rules=true
        getPublicTeam: builder.query<
            ApiContentResponse<PublicTeamTipRules>,
            string
        >({
            query: (teamId: string) => ({
                url: `/public-team/${teamId}?include-tip-rules=true`,
                method: `GET`,
            }),
        }),

        // POST /payment/checkoutId
        getCheckoutId: builder.query<ApiContentResponse<string>, CheckoutDetails>({
            query: (requestBody: CheckoutDetails) => ({
                url: '/payment/checkoutId',
                method: `POST`,
                body: requestBody,
            }),
        }),
        
        // GET /payment/status/checkoutId
        getCheckoutStatus: builder.query<
            ApiContentResponse<CheckoutStatus>,
            string
        >({
            query: (checkoutId: string) => ({
                url: `/payment/status/${checkoutId}`,
                method: `GET`,
            }),
        }),
    }),
});

export const {
    useGetPublicProfileQuery,
    useLazyGetPublicProfileQuery,
    useGetPublicTeamQuery,
    useLazyGetPublicTeamQuery,
    useLazyGetCheckoutIdQuery, 
    useGetCheckoutStatusQuery
} = api;
